import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/reports',
        exact: true,
        auth: true,
        enabled: (config) => config.remote.globalReportGenerator.enabled,
        component: loadable({
            loader: () => import('./pages/ReportsPage'),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
